module.exports = __webpack_public_path__ + "img/logo.de5b5929.png";